import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicIsConnecting = mutatorAction('updateBasicIsConnecting', function (isConnecting) {
    var store = connectedAccountsStore();
    store.connectBasicState.isConnecting = isConnecting;
});
//# sourceMappingURL=updateBasicIsConnecting.js.map